export default __webpack_public_path__ + "static/favicon-abaa174bd7410fa83fd880a7d3904381.ico";